import { render, staticRenderFns } from "./DictionaryKinds.vue?vue&type=template&id=4fcde2be&"
import script from "./DictionaryKinds.vue?vue&type=script&lang=js&"
export * from "./DictionaryKinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports